var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel-wrapper"},[_c('div',{staticClass:"plan-centered-info"},[_vm._v(_vm._s(_vm.t("Logging you out...")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }